import React, { createContext, useState } from 'react'

export const loginOrRegister = createContext()

export default function LoginOrRegisterContext(props) {
  const [logged, setLogged] = useState(false)
  const value = { logged, setLogged }
  return (
    <loginOrRegister.Provider value={value}>
      {props.children}
    </loginOrRegister.Provider>
  )
}
